import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { FileUploadTimeoutInterceptor } from './core/interceptors/file-upload-timeout.interceptor';
import { provideToastr } from 'ngx-toastr';
import { ErrorBoundaryService } from './core/services/error-boundary.service';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DevMissingTranslationHandler } from './core/i18n/missing-translation.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions(),
      // Now that pages scroll with the browser scrollbar, a navigation has to
      // reset the position: without this the router leaves it alone, so
      // clicking a card near the bottom of a long listing opened the profile
      // already scrolled down. 'enabled' also restores the position on Back and
      // Forward; ScrollMemoryDirective adds the case this cannot cover —
      // returning to a listing by an ordinary link, such as the breadcrumb.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([AuthInterceptor, FileUploadTimeoutInterceptor])
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    ...provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json'
    }),
    importProvidersFrom(
      MatDialogModule,
      TranslateModule.forRoot({
        defaultLanguage: 'ar',
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: DevMissingTranslationHandler,
        },
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader
        },
      })
    ),
    {
      provide: ErrorBoundaryService,
      useClass: ErrorBoundaryService
    }
  ]
};